"use client";

import ErrorAlert from "@/components/alerts/errorsAlert";
import ExitoAlert from "@/components/alerts/ExitosAlert";
import React from "react";
import FormRegister from "./Components/Register";
import { useRegisterForm } from "./Hooks/useRegisterForm";

export const RegisterNewClient: React.FC = () => {
    const {
        email,
        password,
        confirmPassword,
        emailError,
        passwordError,
        confirmPasswordError,
        acceptTerms,
        loading,
        tipoDocumento,
        numeroDocumento,
        numeroDocumentoError,
        celular,
        celularError,
        primer_nombre,
        segundo_nombre,
        primer_apellido,
        segundo_apellido,
        tiposIdentificacion,
        loadingTipos,
        areFieldsValid,
        areAllFieldsValid,
        apiErrorUser,
        showErrorAlert,
        showSuccessAlert,
        successData,
        handleEmailInputChange,
        handlePasswordInputChange,
        handleConfirmPasswordInputChange,
        handleSubmit,
        handleAcceptTermsChange,
        handleTipoDocumentoChange,
        handleNumeroDocumentoChange,
        handleTelefonoChange,
        handleRecaptchaVerify,
        handleRecaptchaError,
        handleRecaptchaExpired,
        handlePrimerNombreChange,
        handleSegundoNombreChange,
        handlePrimerApellidoChange,
        handleSegundoApellidoChange,
        handleCloseErrorAlert,
        handleCloseSuccessAlert,
    } = useRegisterForm();

    return (
        <>
            <FormRegister
                email={email}
                password={password}
                confirmPassword={confirmPassword}
                emailError={emailError}
                passwordError={passwordError}
                confirmPasswordError={confirmPasswordError}
                acceptTerms={acceptTerms}
                onAcceptTermsChange={handleAcceptTermsChange}
                isCheckboxDisabled={!areFieldsValid}
                isSubmitDisabled={!areAllFieldsValid}
                tipoDocumento={tipoDocumento}
                numeroDocumento={numeroDocumento}
                numeroDocumentoError={numeroDocumentoError}
                onTipoDocumentoChange={handleTipoDocumentoChange}
                onNumeroDocumentoChange={handleNumeroDocumentoChange}
                celular={celular}
                celularError={celularError}
                onCelularChange={handleTelefonoChange}
                onEmailChange={handleEmailInputChange}
                onPasswordChange={handlePasswordInputChange}
                onConfirmPasswordChange={handleConfirmPasswordInputChange}
                onSubmit={handleSubmit}
                onRecaptchaVerify={handleRecaptchaVerify}
                onRecaptchaError={handleRecaptchaError}
                onRecaptchaExpired={handleRecaptchaExpired}
                loading={loading}
                primer_nombre={primer_nombre}
                segundo_nombre={segundo_nombre}
                primer_apellido={primer_apellido}
                segundo_apellido={segundo_apellido}
                onPrimerNombreChange={handlePrimerNombreChange}
                onSegundoNombreChange={handleSegundoNombreChange}
                onPrimerApellidoChange={handlePrimerApellidoChange}
                onSegundoApellidoChange={handleSegundoApellidoChange}
                tiposIdentificacion={tiposIdentificacion}
                loadingTipos={loadingTipos}
            />

            {showErrorAlert && apiErrorUser && (
                <ErrorAlert
                    title="Error de registro"
                    message={apiErrorUser}
                    onClose={handleCloseErrorAlert}
                />
            )}

            {showSuccessAlert && successData && (
                <ExitoAlert
                    title={successData.title}
                    message={successData.message}
                    onClose={handleCloseSuccessAlert}
                />
            )}
        </>
    );
};

export default RegisterNewClient;
